import React from 'react';
import { InfoCard, Progress } from '@backstage/core-components';
import { Box, Typography } from '@material-ui/core';
import { useCredentials } from './useCredentials';
import { Credentials } from '@app/shared/types';
import { InfoItem } from '../InfoItem/UserInfoField';

type CredentialsCardProps = {
  userID?: string;
};

const ClientCredentials = ({ id, secret }: { id: string; secret: string }) => (
  <Box display="flex" flexDirection="column" style={{ gap: 24 }}>
    <InfoItem title="Client ID" value={id} withCopy />
    <InfoItem title="Client Secret" value={secret} withCopy withSecret />
  </Box>
);

const CredentialsCard = ({ userID }: CredentialsCardProps) => {
  const { data, isLoading, error } = useCredentials(userID);
  const dxmCredentials = data?.dxm ?? [];
  const externalCredentials = data?.external ?? [];

  if (error) {
    return null;
  }

  if (isLoading) {
    return (
      <InfoCard title="Client credentials">
        <Progress />
      </InfoCard>
    );
  }

  if (error || !dxmCredentials.length) {
    return (
      <InfoCard title="Client credentials">
        <Typography
          variant="subtitle2"
          gutterBottom
          style={{
            fontSize: '0.875rem',
            paddingLeft: '16px',
            paddingTop: '12px',
          }}
        >
          The user's client credentials are unavailable. Contact your manager or
          the support team to resolve the issue.
        </Typography>
      </InfoCard>
    );
  }

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 24 }}>
      {dxmCredentials.map((userCredentials: Credentials) => (
        <InfoCard title={userCredentials.name} key={userCredentials.clientId}>
          <ClientCredentials
            id={userCredentials.clientId}
            secret={userCredentials.clientSecret}
          />
        </InfoCard>
      ))}
      {externalCredentials?.map((userCredentials: Credentials) => (
        <InfoCard title={userCredentials.name} key={userCredentials.clientId}>
          <ClientCredentials
            id={userCredentials.clientId}
            secret={userCredentials.clientSecret}
          />
        </InfoCard>
      ))}
    </Box>
  );
};

export default CredentialsCard;
